import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './email.css'; // Optional styling

const Email = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // ✅ View form data before sending
    const formData = new FormData(form.current);
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

  emailjs.sendForm(
  'service_lmw7srp',       // Your Service ID
  'template_f7hf6s2',      // Your Template ID
  form.current,            // Your form reference
  'Io7FDVcIsh81sb9gC'      // ✅ Your Public Key from the dashboard
      // Your EmailJS Public Key
    ).then(
      (result) => {
        alert('Message sent successfully!');
        form.current.reset(); // Clear form
      },
      (error) => {
        alert('Failed to send message. Please try again.');
        console.error('EmailJS Error:', error);
      }
    );
  };

  return (
    <div className="contact-form-container-1">
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <h2 className='logo_title'>Contact Us</h2>
        <input type="text" name="name" placeholder="Your Name" required />
        <input type="email" name="email" placeholder="Your Email" required />
        <input type="text" name="contact" placeholder="Your Contact Number" required />
        <input type="text" name="title" placeholder="Subject" required />
        <textarea name="message" placeholder="Your Message" required />
        <input type="hidden" name="time" value={new Date().toLocaleString()} />
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
};

export default Email;
